import { useEffect, useState } from 'react'
import { useAtomValue } from 'jotai'
import { useMatch } from 'react-router-dom'
import { Contact } from '@node-space/types'
import { CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { PathNames } from 'constants/General'
import { contactAtom } from '../atoms/contactAtoms'

export const getContactBreadcrumbs = ({ contact }: { contact: Contact }) => {
  const contactPageBreadcrumb = contact
    ? [
        ...(contact?.name
          ? [
              {
                title: contact?.name,
              },
            ]
          : []),
      ]
    : []

  return [...contactPageBreadcrumb]
}

export const useContactPageBreadcrumbs = () => {
  const [contactPageBreadcrumbs, setContactPageBreadcrumbs] = useState<CustomBreadCrumbConfig[]>([])
  const contact = useAtomValue(contactAtom)
  const match = useMatch(PathNames.CONTACT)

  useEffect(() => {
    const breadcrumbs = getContactBreadcrumbs({ contact })
    setContactPageBreadcrumbs(match ? breadcrumbs : [])
  }, [contact, match])

  return contactPageBreadcrumbs
}
